import { SelectOption } from 'src/common/primitives/Select';

export function pluckSelectOptionByValue(
  value: string | undefined,
  options: SelectOption[]
): SelectOption | undefined {
  return options.find((option) => option.value === value);
}
